import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import LpCta from "./LpCta";
import { FAQ } from "./lpData";

const LpFaq = () => (
  <section className="section-pad bg-[#E6F8FF]" data-testid="lp-faq">
    <div className="aevos-container grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <h2 className="font-display font-bold text-3xl md:text-5xl leading-[1.08]">
          Dúvidas comuns antes da primeira consulta
        </h2>
        <p className="mt-5 text-[#333333] text-base leading-relaxed">
          Não encontrou sua resposta? Fale diretamente com a equipe.
        </p>
        <div className="mt-8">
          <LpCta location="faq" message="Olá! Vim pela página de emagrecimento da AEVOS e tenho algumas dúvidas.">
            Tirar dúvidas pelo WhatsApp
          </LpCta>
        </div>
      </div>

      <div className="lg:col-span-8 bg-white border border-[#E0E0E0] px-6 md:px-8">
        <Accordion type="single" collapsible data-testid="lp-faq-accordion">
          {FAQ.map((item, i) => (
            <AccordionItem key={item.q} value={`faq-${i}`} className="border-[#E0E0E0]">
              <AccordionTrigger
                className="font-display font-semibold text-left text-black text-sm md:text-base hover:no-underline hover:text-[#00C4FF] py-5"
                data-testid={`lp-faq-trigger-${i}`}
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#333333] text-sm md:text-base leading-relaxed pb-5">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default LpFaq;
